import { SelectOptionProps } from '@acceso/design-system';

import { useLanguages } from '../api/get-languages';

export function useLanguageOptions(): SelectOptionProps<string>[] {
  const { data: languages = [] } = useLanguages();
  const languageOptions: SelectOptionProps<string>[] = languages.map(language => ({
    label: language.name,
    value: language.id,
  }));

  return languageOptions;
}
